<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="licenciaForm" @submit.prevent="registrarLicencia">
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-4">Nueva Licencia</div>
            </v-col>
            <v-col cols="6">
              <BaseInput label="Numero de oficio" />
            </v-col>
            <v-col cols="6">
              <BaseInput label="Remesa" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.direccion" label="Dirección" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.noLicencia" label="Numero de Licencia" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.nombreInstancia" label="Nombre instancia" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.representanteLegal" label="Representante legal" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.rm" label="RM" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.titular" label="Titular" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.vigencia" label="Vigencia" />
            </v-col>
            <v-col cols="6">
              <BaseInput v-model="licenciaOficialColectiva.zm" label="ZM" />
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model="licenciaOficialColectiva.fechaAlta"
                label="Fecha alta"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model="licenciaOficialColectiva.fechaTramite"
                label="Fecha tramite"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :loading="loading" @click="registrarLicencia"> Registrar Licencia </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      licenciaForm: false,
      loading: false,
      licenciaOficialColectiva: {
        direccion: '',
        noLicencia: '',
        nombreInstancia: '',
        representanteLegal: '',
        rm: '',
        titular: '',
        vigencia: '',
        zm: '',
        fechaAlta: '',
        fechaTramite: '',
      },
    }
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', ['saveLoc']),
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    limpiarFormulario() {
      this.licenciaOficialColectiva = {
        direccion: '',
        noLicencia: '',
        nombreInstancia: '',
        representanteLegal: '',
        rm: '',
        titular: '',
        vigencia: '',
        zm: '',
        fechaAlta: '',
        fechaTramite: '',
      }
      this.$refs.form && this.$refs.form.resetValidation()
    },
    async registrarLicencia() {
      this.loading = true
      try {
        const payload = {
          ...this.licenciaOficialColectiva,
          fechaAlta: this.licenciaOficialColectiva.fechaAlta
            ? moment(this.licenciaOficialColectiva.fechaAlta, 'DD/MM/YYYY').format('DD/MM/YYYY')
            : '',
          fechaTramite: this.licenciaOficialColectiva.fechaTramite
            ? moment(this.licenciaOficialColectiva.fechaTramite, 'DD/MM/YYYY').format('DD/MM/YYYY')
            : '',
        }
        await this.saveLoc({ loc: payload })
        this.limpiarFormulario()
        await this.fetchLocs()
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
